/*global MakeTextRequestURL */
/*eslint no-undef: "error"*/
import React, { Component } from 'react';
import { connect }          from 'react-redux';
import moment               from 'moment';
import validator            from 'validator';
import { v2Api }            from 'moovila-common';

import {
  getAPIMethods,
  showMessageBox,
} from '../../actions';

import APIConsole from '../../components/Utilities/APIConsole';

class APIConsoleContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      response: '',
      results: null,
      timer: null, // null === no query, 0 === querying, moment.diff() for timer result
      isCached: false,
    }
    this.printAPIDictionary = this.printAPIDictionary.bind(this);
    this.hasRequiredParams  = this.hasRequiredParams.bind(this);
    this.executeAPITest     = this.executeAPITest.bind(this);
    this.executeAPITest10x  = this.executeAPITest10x.bind(this);
  }

  componentWillMount() {
    this.props.getAPIMethods();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.subject !== nextProps.subject || this.props.request !== nextProps.request) {
      this.setState({
        response: '',
        results: null,
        timer: null,
        isCached: false,
      });
    }
  }

  printAPIDictionary(detail=false) {
    const method = detail ? 'GetAPIDictionaryDetail' : 'GetAPIDictionary';
    const url = MakeTextRequestURL('Reporting', method, JSON.stringify({reportFormat: 'PDF'}));
    window.open(url, '_blank');
  }

  hasRequiredParams(endpoint, params) {
    let message;
    if (endpoint.RequiresParms && !params.trim()) {
      message = 'One or more parameters are required for this request.';
    } else if (params && !validator.isJSON(params)) {
      message = 'Invalid JSON'
    }
    if (message) {
      this.setState({
        timer: null, // reset. indicates no present query
      });
      this.props.showMessageBox({
        title: 'Invalid Parameters',
        message,
      });
      return false;
    }
    return true;
  }

  fetchWithTimer(subject, request, params, ifNeeded=false) {
    const start = moment();
    return new Promise((res, rej) => {
      if (ifNeeded) {
        v2Api.fetchIfNeeded(`${subject}/${request}`, params)
          .then((responseData) => {
            res({data: responseData.data, header: responseData.header, time: moment().diff(start)})
          })
          .catch(({errCode, errMessage}) => rej({errCode, errMessage, time: moment().diff(start)}));
      } else {
        v2Api.fetch(`${subject}/${request}`, params)
          .then(({data, header}) => {
            res({data, header, time: moment().diff(start)})
          })
          .catch(({errCode, errMessage}) => rej({errCode, errMessage, time: moment().diff(start)}));
        }
    });
  }

  executeAPITest(params, ifNeeded=false) {
    const { subject, request } = this.props;
    const endpoint = this.props.api.subjects.filter(sub => sub.Subject === subject)[0].APICalls.filter(call => call.Request === request)[0];

    if (!this.hasRequiredParams(endpoint, params)) {
      return;
    }

    const p = params.trim().length ? JSON.parse(params) : null;
    this.setState({timer: 0, results: null}); // indicates beginning of query

    this.fetchWithTimer(subject, request, p, ifNeeded)
      .then(res => {
        let isCached = false;
        if (res.header && !res.header.dataChanged && ifNeeded) {
          this.setState({timer: res.time, response: 'Data did not change.'})
        } else {
          this.setState({timer: res.time, response: JSON.stringify(res.data, null, '  ')})
        }
        if (res.header && res.header.usedCache) {
          isCached = true;
        }
        this.setState({isCached});
      })
      .catch(({errCode, errMessage, time}) => this.setState({timer: time, response: `// error (error code: ${errCode}) ${errMessage}`}));
  }

  execute10xTestStep(subject, request, p) {
    this.fetchWithTimer(subject, request, p)
      .then(res => {
        const parsedResults = JSON.parse(this.state.results);
        if (parsedResults.length < 10) {
          this.setState({results: JSON.stringify([...parsedResults, res.time], null, '  ')});
          this.execute10xTestStep(subject, request, p);
          return;
        }
        const average = parsedResults.reduce((sum, val) => sum + val, 0) / parsedResults.length;
        this.setState({
          timer: average.toFixed(0),
          results: JSON.stringify([
            ...parsedResults,
            '------------------',
            'RESULTS:',
            `average time: ${average.toFixed(0)}`,
            '(all times in ms)',
          ], null, '  ')
        });
      })
      .catch(({errCode, errMessage, time}) => this.setState({timer: time, response: `// error (error code: ${errCode}) ${errMessage}`}));
  }

  executeAPITest10x(params) {
    const { subject, request } = this.props;
    const endpoint = this.props.api.subjects.filter(sub => sub.Subject === subject)[0].APICalls.filter(call => call.Request === request)[0];

    if (!this.hasRequiredParams(endpoint, params)) {
      return;
    }

    const p = params.trim().length ? JSON.parse(params) : null;

    this.setState({
      results: '[]',
      timer: 0,
    })

    this.execute10xTestStep(subject, request, p);
  }

  render() {
    const { api } = this.props;
    if (!api) {
      return null;
    }
    return (
      <APIConsole
        api={api}
        printAPIDictionary={this.printAPIDictionary}
        method={this.props.method}
        subject={this.props.subject}
        request={this.props.request}
        timer={this.state.timer}
        results={this.state.results}
        executeAPITest={this.executeAPITest}
        executeAPITest10x={this.executeAPITest10x}
        response={this.state.response}
        isCached={this.state.isCached}
      />
    );
  }
}

export default connect(
  state => state,
  { getAPIMethods, showMessageBox }
)(APIConsoleContainer);



// WEBPACK FOOTER //
// ./src/containers/Utilities/APIConsole.js